/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthTokenMetaUser
 */
export interface AuthTokenMetaUser {
    /**
     * 
     * @type {string}
     * @memberof AuthTokenMetaUser
     */
    email: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AuthTokenMetaUser
     */
    hasPassword: boolean;
}

/**
 * Check if a given object implements the AuthTokenMetaUser interface.
 */
export function instanceOfAuthTokenMetaUser(value: object): value is AuthTokenMetaUser {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('hasPassword' in value) || value['hasPassword'] === undefined) return false;
    return true;
}

export function AuthTokenMetaUserFromJSON(json: any): AuthTokenMetaUser {
    return AuthTokenMetaUserFromJSONTyped(json, false);
}

export function AuthTokenMetaUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthTokenMetaUser {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'hasPassword': json['hasPassword'],
    };
}

  export function AuthTokenMetaUserToJSON(json: any): AuthTokenMetaUser {
      return AuthTokenMetaUserToJSONTyped(json, false);
  }

  export function AuthTokenMetaUserToJSONTyped(value?: AuthTokenMetaUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'hasPassword': value['hasPassword'],
    };
}

